<div class="section-row">
  <div class="sub-section">
    <ag-grid-angular
      style="width: 100%;"
      [ngStyle]="{'height': this.pagingInfo.pageSize === this.pagingInfo.totalRows ? '' : '345px'}"
      class="ag-theme-balham"
      [rowData]="rowData"
      [columnDefs]="columnDefs"
      (gridReady)="onGridReady($event)"
      (gridSizeChanged)="onGridSizeChanged()"
      (filterChanged)="onFilterChanged()"
      [pagination]="true"
      [paginationPageSize]="pagingInfo.pageSize"
      [enableBrowserTooltips]="true">
    </ag-grid-angular>
    <app-pagination-control *ngIf="rowData.length > 0 && (indexType === 'iboxx' || indexType === 'emix')" [input]="this.pagingInfo" [showAll]="true" (pageChanged)="changePage()"></app-pagination-control>
  </div>
</div>
